import React, { useState } from 'react'
import classes from './AppCard.module.css'
import buttonClasses from './ButtonClasses.module.css'

import { Button, SvgIcon } from '@material-ui/core';
import { StylesProvider } from '@material-ui/core/styles';


export const THEME_DARK = "dark";
export const THEME_LIGHT = "light";

const IconWeb = (props) => {
    return (
        <SvgIcon {...props}>

            <path d="M2.57141 2.67153C2.57141 2.6163 2.61618 2.57153 2.67141 2.57153H4.1857C4.24093 2.57153 4.2857 2.6163 4.2857 2.67153V4.18582C4.2857 4.24105 4.24093 4.28582 4.1857 4.28582H2.67141C2.61618 4.28582 2.57141 4.24105 2.57141 4.18582V2.67153Z" />
            <path d="M6 2.67153C6 2.6163 6.04477 2.57153 6.1 2.57153H7.61429C7.66951 2.57153 7.71429 2.6163 7.71429 2.67153V4.18582C7.71429 4.24105 7.66951 4.28582 7.61429 4.28582H6.1C6.04477 4.28582 6 4.24105 6 4.18582V2.67153Z" />
            <path d="M9.42847 2.67153C9.42847 2.6163 9.47324 2.57153 9.52847 2.57153H11.0428C11.098 2.57153 11.1428 2.6163 11.1428 2.67153V4.18582C11.1428 4.24105 11.098 4.28582 11.0428 4.28582H9.52847C9.47324 4.28582 9.42847 4.24105 9.42847 4.18582V2.67153Z" />
            <path d="M22.5 0H1.5C1.10218 0 0.720644 0.180612 0.43934 0.502103C0.158035 0.823594 0 1.25963 0 1.71429V22.2857C0 22.7404 0.158035 23.1764 0.43934 23.4979C0.720644 23.8194 1.10218 24 1.5 24H22.5C22.8978 24 23.2794 23.8194 23.5607 23.4979C23.842 23.1764 24 22.7404 24 22.2857V1.71429C24 1.25963 23.842 0.823594 23.5607 0.502103C23.2794 0.180612 22.8978 0 22.5 0ZM22.5 4.31429C22.5 4.86657 22.0523 5.31429 21.5 5.31429H2.5C1.94772 5.31429 1.5 4.86657 1.5 4.31429V2.71429C1.5 2.162 1.94772 1.71429 2.5 1.71429H21.5C22.0523 1.71429 22.5 2.162 22.5 2.71429V4.31429Z" />

        </SvgIcon>
    )
}

const IconGooglePlay = (props) => {
    return (
        <SvgIcon {...props}>
            <path d="M15.447 10.9854L4.81805 0.609883L18.3411 8.16779L15.447 10.9854ZM2.04486 0C1.41841 0.31882 1 0.900197 1 1.65486V22.3451C1 23.0998 1.41918 23.6812 2.04486 24L14.4029 11.9974L2.04486 0ZM22.5213 10.5773L19.685 8.97871L16.5211 12.0026L19.685 15.0265L22.5791 13.4279C23.446 12.758 23.446 11.248 22.5213 10.5773ZM4.81882 23.3961L18.3419 15.8382L15.4477 13.0206L4.81882 23.3961Z" />
        </SvgIcon>
    )
}

const IconApple = (props) => {
    return (
        <SvgIcon {...props}>
            <path d="M21.8249 18.7033C21.4746 19.5184 21.0418 20.2956 20.5333 21.0229C19.854 21.9914 19.2961 22.6607 18.8685 23.0332C18.2043 23.6418 17.4908 23.9549 16.728 23.9726C16.1815 23.9726 15.5211 23.8173 14.7519 23.5016C13.9802 23.1872 13.2718 23.0332 12.6228 23.0332C11.9435 23.0332 11.2148 23.1872 10.4342 23.5016C9.65495 23.8173 9.02494 23.9827 8.54295 23.9979C7.813 24.0294 7.08306 23.7087 6.35564 23.0332C5.89136 22.6291 5.31069 21.9346 4.61364 20.9522C3.86725 19.9054 3.25369 18.6869 2.77296 17.3017C2.25807 15.8029 2 14.3533 2 12.9491C2 11.3417 2.34789 9.95397 3.04495 8.79228C3.57217 7.87993 4.32589 7.11847 5.23352 6.58127C6.12852 6.04546 7.15022 5.75695 8.19379 5.74535C8.77572 5.74535 9.53856 5.92465 10.4836 6.27821C11.4286 6.63177 12.0358 6.81108 12.3002 6.81108C12.5001 6.81108 13.1718 6.60021 14.3155 6.18225C15.3946 5.79459 16.3054 5.63423 17.0518 5.69737C19.0759 5.86026 20.5953 6.65577 21.6061 8.09021C19.797 9.18498 18.9026 10.7167 18.9203 12.6827C18.9355 14.2144 19.4934 15.4885 20.5864 16.4999C21.0697 16.9615 21.6335 17.3308 22.25 17.5896C22.1159 17.9773 21.9742 18.3472 21.8249 18.7033V18.7033ZM17.1859 0.481094C17.1859 1.68067 16.7457 2.80196 15.8715 3.83865C14.8139 5.07106 13.5362 5.78449 12.1509 5.67211C12.1328 5.52127 12.1239 5.36946 12.1244 5.21753C12.1244 4.06468 12.6253 2.83227 13.5197 1.82336C13.965 1.31322 14.5318 0.887688 15.2187 0.549281C15.9044 0.215924 16.5521 0.0315679 17.1619 0C17.1783 0.161627 17.1859 0.321992 17.1859 0.481094V0.481094Z" />
        </SvgIcon>
    )
}

const AppCard = (props) => {

    const [hovered, setHovered] = useState(false);

    const handleHover = () => setHovered(true);
    const handleFinishHover = () => setHovered(false);



    let textMainColor = "black";
    let textSecondaryColor = "rgba(0,0,0,0.54)"
    let imageColor = "#262F56";
    if (props.theme === THEME_DARK) {
        textMainColor = "rgba(255,255,255,0.87)";
        textSecondaryColor = "rgba(255,255,255,0.6)";
        imageColor = "rgba(255,255,255,0.87)";
    }

    let iconWeb = null;
    let iconGooglePlay = null;
    let iconApple = null;
    if (props.web) {
        iconWeb =
            <svg width="16" height="16" viewBox="0 0 24 24">
                <path d="M2.57141 2.67153C2.57141 2.6163 2.61618 2.57153 2.67141 2.57153H4.1857C4.24093 2.57153 4.2857 2.6163 4.2857 2.67153V4.18582C4.2857 4.24105 4.24093 4.28582 4.1857 4.28582H2.67141C2.61618 4.28582 2.57141 4.24105 2.57141 4.18582V2.67153Z" fill={imageColor} />
                <path d="M6 2.67153C6 2.6163 6.04477 2.57153 6.1 2.57153H7.61429C7.66951 2.57153 7.71429 2.6163 7.71429 2.67153V4.18582C7.71429 4.24105 7.66951 4.28582 7.61429 4.28582H6.1C6.04477 4.28582 6 4.24105 6 4.18582V2.67153Z" fill={imageColor} />
                <path d="M9.42847 2.67153C9.42847 2.6163 9.47324 2.57153 9.52847 2.57153H11.0428C11.098 2.57153 11.1428 2.6163 11.1428 2.67153V4.18582C11.1428 4.24105 11.098 4.28582 11.0428 4.28582H9.52847C9.47324 4.28582 9.42847 4.24105 9.42847 4.18582V2.67153Z" fill={imageColor} />
                <path d="M22.5 0H1.5C1.10218 0 0.720644 0.180612 0.43934 0.502103C0.158035 0.823594 0 1.25963 0 1.71429V22.2857C0 22.7404 0.158035 23.1764 0.43934 23.4979C0.720644 23.8194 1.10218 24 1.5 24H22.5C22.8978 24 23.2794 23.8194 23.5607 23.4979C23.842 23.1764 24 22.7404 24 22.2857V1.71429C24 1.25963 23.842 0.823594 23.5607 0.502103C23.2794 0.180612 22.8978 0 22.5 0ZM22.5 4.31429C22.5 4.86657 22.0523 5.31429 21.5 5.31429H2.5C1.94772 5.31429 1.5 4.86657 1.5 4.31429V2.71429C1.5 2.162 1.94772 1.71429 2.5 1.71429H21.5C22.0523 1.71429 22.5 2.162 22.5 2.71429V4.31429Z" fill={imageColor} />
            </svg>
    }
    if (props.android) {
        iconGooglePlay =
            <svg width="16" height="16" viewBox="0 0 24 24" >
                <path d="M15.447 10.9854L4.81805 0.609883L18.3411 8.16779L15.447 10.9854ZM2.04486 0C1.41841 0.31882 1 0.900197 1 1.65486V22.3451C1 23.0998 1.41918 23.6812 2.04486 24L14.4029 11.9974L2.04486 0ZM22.5213 10.5773L19.685 8.97871L16.5211 12.0026L19.685 15.0265L22.5791 13.4279C23.446 12.758 23.446 11.248 22.5213 10.5773ZM4.81882 23.3961L18.3419 15.8382L15.4477 13.0206L4.81882 23.3961Z"
                    fill={imageColor} />
            </svg>
    }
    if (props.apple) {
        iconApple =
            <svg width="16" height="16" viewBox="0 0 24 24">
                <path d="M21.8249 18.7033C21.4746 19.5184 21.0418 20.2956 20.5333 21.0229C19.854 21.9914 19.2961 22.6607 18.8685 23.0332C18.2043 23.6418 17.4908 23.9549 16.728 23.9726C16.1815 23.9726 15.5211 23.8173 14.7519 23.5016C13.9802 23.1872 13.2718 23.0332 12.6228 23.0332C11.9435 23.0332 11.2148 23.1872 10.4342 23.5016C9.65495 23.8173 9.02494 23.9827 8.54295 23.9979C7.813 24.0294 7.08306 23.7087 6.35564 23.0332C5.89136 22.6291 5.31069 21.9346 4.61364 20.9522C3.86725 19.9054 3.25369 18.6869 2.77296 17.3017C2.25807 15.8029 2 14.3533 2 12.9491C2 11.3417 2.34789 9.95397 3.04495 8.79228C3.57217 7.87993 4.32589 7.11847 5.23352 6.58127C6.12852 6.04546 7.15022 5.75695 8.19379 5.74535C8.77572 5.74535 9.53856 5.92465 10.4836 6.27821C11.4286 6.63177 12.0358 6.81108 12.3002 6.81108C12.5001 6.81108 13.1718 6.60021 14.3155 6.18225C15.3946 5.79459 16.3054 5.63423 17.0518 5.69737C19.0759 5.86026 20.5953 6.65577 21.6061 8.09021C19.797 9.18498 18.9026 10.7167 18.9203 12.6827C18.9355 14.2144 19.4934 15.4885 20.5864 16.4999C21.0697 16.9615 21.6335 17.3308 22.25 17.5896C22.1159 17.9773 21.9742 18.3472 21.8249 18.7033V18.7033ZM17.1859 0.481094C17.1859 1.68067 16.7457 2.80196 15.8715 3.83865C14.8139 5.07106 13.5362 5.78449 12.1509 5.67211C12.1328 5.52127 12.1239 5.36946 12.1244 5.21753C12.1244 4.06468 12.6253 2.83227 13.5197 1.82336C13.965 1.31322 14.5318 0.887688 15.2187 0.549281C15.9044 0.215924 16.5521 0.0315679 17.1619 0C17.1783 0.161627 17.1859 0.321992 17.1859 0.481094V0.481094Z"
                    fill={imageColor} />
            </svg>
    }

    let imageLayoutClasses = [classes.imageLayout];
    if (hovered) imageLayoutClasses.push(classes.imageLayoutHovered);


    const buttons = [props.apple, props.android, props.web].map((b, i) => {

        if (b) {
            const {enter, rootDark, labelDark, ...cls} = buttonClasses;
            let additionalStyle = null;
            if (props.theme === THEME_DARK) {
                cls.root = rootDark;
                cls.label = labelDark;
                
            }
            switch (i) {
                case 0:
                    return <Button key={b} classes={cls} startIcon={<IconApple />} href={b} style={additionalStyle} >Apple</Button>
                case 1:
                    return <Button key={b} classes={cls} startIcon={<IconGooglePlay />} href={b} style={additionalStyle}>Google Play</Button>
                case 2:
                    return <Button key={b} classes={cls} startIcon={<IconWeb />} href={b} style={additionalStyle}>Web App</Button>
                default:
                    return null
            }
        }
        return null
    })

    return (
        <div className={classes.container} style={{ backgroundColor: props.color }}
            onMouseEnter={() => handleHover()}
            onMouseLeave={() => handleFinishHover()}>
            <div className={classes.opsContainer}>
                {iconWeb}
                {iconApple}
                {iconGooglePlay}
            </div>
            <div className={imageLayoutClasses.join(" ")}>
                <img src={props.image} className={classes.image} alt={props.title} style={{ border: "1px solid " + props.color }} />
                <div className={classes.shadow} style={{ boxShadow: "inset 0 0 8px 8px " + props.color }} />
            </div>

            <p className={classes.title} style={{ color: textMainColor }}>{props.title}</p>
            <p className={classes.desc} style={{ color: textSecondaryColor }}>{props.description}</p>
            <div className={classes.links} style={{display: hovered ? "block" : "none"}}>
                <StylesProvider injectFirst>
                    {buttons}
                </StylesProvider>

            </div>
        </div>
    )
}

export default AppCard
